import React, { FC } from 'react';

import { useIntl } from 'react-intl';

import { StyledRewardPointCost } from './reward-point-cost.styled';

export interface IRewardPointCost {
  pointCost: number;
  usePrimaryColor?: boolean;
}

export const RewardPointCost: FC<IRewardPointCost> = ({ pointCost, usePrimaryColor, children }) => {
  const { formatMessage } = useIntl();

  return pointCost === 0 ? (
    <StyledRewardPointCost usePrimaryColor={usePrimaryColor}>
      {formatMessage({ id: 'free' }).toLocaleLowerCase()}
    </StyledRewardPointCost>
  ) : (
    <>{children}</>
  );
};
